export const Constants = {
  GOOGLE_CLIENT_ID:  "941661864115-rn9hjldu30r4nnd3pk6k5ft7j5hsl7rd.apps.googleusercontent.com",
  FB_APP_ID: "1344627055874808"
};
